var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUniconRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00001 7.00567L8.59001 7.00567L5.29001 10.2957C5.10171 10.484 4.99592 10.7394 4.99592 11.0057C4.99592 11.272 5.10171 11.5274 5.29001 11.7157C5.47832 11.904 5.73371 12.0098 6.00001 12.0098C6.26631 12.0098 6.52171 11.904 6.71001 11.7157L11.71 6.71567C11.8011 6.62057 11.8724 6.50843 11.92 6.38567C12.02 6.14221 12.02 5.86913 11.92 5.62567C11.8724 5.50292 11.8011 5.39078 11.71 5.29567L6.71001 0.295675C6.61705 0.201947 6.50645 0.127551 6.38459 0.0767822C6.26273 0.0260134 6.13202 -0.000123978 6.00001 -0.000123978C5.868 -0.000123978 5.73729 0.0260134 5.61544 0.0767822C5.49358 0.127551 5.38298 0.201947 5.29001 0.295675C5.19628 0.388638 5.12189 0.499238 5.07112 0.621098C5.02035 0.742957 4.99421 0.873663 4.99421 1.00567C4.99421 1.13769 5.02035 1.26839 5.07112 1.39025C5.12189 1.51211 5.19628 1.62271 5.29001 1.71567L8.59001 5.00567L1.00001 5.00567C0.734796 5.00567 0.480441 5.11103 0.292905 5.29857C0.105369 5.4861 1.23978e-05 5.74046 1.23978e-05 6.00567C1.23978e-05 6.27089 0.105369 6.52524 0.292905 6.71278C0.480441 6.90032 0.734796 7.00567 1.00001 7.00567Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniconRight);
export default __webpack_public_path__ + "static/media/uniconRight.02b1b735c7b7b1fd94eaf3096bb39dff.svg";
export { ForwardRef as ReactComponent };